import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid , Header , Image , Button , Segment , Icon } from 'semantic-ui-react';
import ThemeColorSetting from '../../../constants/themeColor';
import hardwareImage from '../../../assets/home/hardware.png';
import softwareImage from '../../../assets/home/software.png';
import serviceImage from '../../../assets/home/service.png';
import waveGraph from '../../../assets/pattern/bank-note.svg';

const styles = {
  container : {
    backgroundColor : ThemeColorSetting.white,
    backgroundImage: 'url(' +waveGraph+ ')',
		backgroundSize : '100px auto',
		backgroundRepeat : 'repeat'
  },
  caseContainer : {
    display : 'flex',
    flexDirection : 'column',
    alignItems : 'center'
  },
  segmentContainer : {
    width : '80%',
    display : 'flex',
    flexDirection : 'column',
    alignItems : 'center',
		justifyContent : 'center',
		height : '40vh'
  },
  header : {
  },
  description : {
    fontSize : '18px',
    width : '80%'
  }
}

class PricePitch extends Component {
  constructor(props){
    super(props);
    this.state = {
      pricingItems : [
        { name : 'hardware' , description : 'hardwareDescription' , image : hardwareImage , icon : 'print' },
        { name : 'software' , description : 'softwareDescription' , image : softwareImage , icon : 'tablet' },
        { name : 'service' , description : 'serviceDescription' , image : serviceImage  , icon : 'phone' },
      ]
    }
  }
  renderPricingItem(pricingItem){
    const { string } = this.props;
    return(
      <Grid.Column key={pricingItem.name} style={styles.caseContainer}>
        <Segment style={styles.segmentContainer} textAlign='center'>
          <Header as='h1' style={styles.header} icon>
						<Icon name={pricingItem.icon}/>
						{string[pricingItem.name]}
					</Header>
          <p style={styles.description}>{string[pricingItem.description]}</p>
        </Segment>
      </Grid.Column>
    )
  }
  render() {
    const { string } = this.props;
    const { pricingItems } = this.state;
    return(
      <Grid.Row columns='3' style={styles.container}>
        {pricingItems.map((pricingItem)=>this.renderPricingItem(pricingItem))}
      </Grid.Row>
    )
  }
}

function mapStateToProps(state) {
  return {
    string : state.preference.string
  }
}

export default connect(mapStateToProps,null)(PricePitch)



/** WEBPACK FOOTER **
 ** ./src/containers/pitch/price/pricePitch.js
 **/